import React from "react";
import Text from "../../../../Components/Text/Text";
import MyButton from "../../../../Components/Button/Button";
import ImageComp from "../../../../Components/ImageComp/ImageComp";
import HeaderSection from "../../../../Components/HeaderSection/HeaderSection";

import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import SwiperCore, { Scrollbar, A11y } from "swiper";
import { Autoplay } from "swiper";

export default function EachPressReleaseComponent({
  PressHeading,
  PressDate,
  PressDetails,
  PressDetails2,
  PressImage,
  PressImageWidth,
  PressImageCaption,
  ContactOne,
  ContactOneName,
  ContactOneEmail,
  ContactOnePhone,
  ContactOneEmailLink,
  ContactTwo,
  ContactTwoName,
  ContactTwoEmail,
  ContactTwoPhone,
  ContactTwoEmailLink,
  OldContactNameOne,
  OldContactOneEmailLink,
  OldContactTwoEmailLink,
  OldContactNameTwo,
  ContactUsHeading,
  ForAnyQuery,
  MuizzContact,
  TopDetails,
  SpecialSectionForDisruptX,
  PressImageSlider1,
  PressImageSlider2,
}) {
  return (
    <>
      <div className="Page_Body">
        <div className="Page_Body_wraper">
          <HeaderSection
            text="Media Center   <span>/</span>"
            text1="  Our News"
            RouteLink1="/our_news"
            Color1="#6C6C6C"
            Color2="black"
          />
          <div className="PressReleaseBody">
            <div className="MousSigningCeremonyPress">
              <div className="PressReleaseBodyTopText">
                <Text
                  text={PressHeading}
                  FontWeight="900"
                  FontSize={"3.5rem"}
                  font
                  Margin="50px 0px 0px 0px"
                />
                {!TopDetails && (
                  <Text
                    text={PressDate}
                    FontWeight="500"
                    Color="#808080"
                    FontSize={"1.8rem"}
                    font
                    Margin="20px 0px 50px 0px"
                  />
                )}
                {TopDetails && (
                  <>
                    <Text
                      text={PressDate}
                      FontWeight="500"
                      Color="#808080"
                      FontSize={"1.8rem"}
                      font
                      Margin="50px 0px 20px 0px"
                    />
                    <Text
                      text={TopDetails}
                      FontSize={"3.2rem"}
                      Margin="0px 0px 50px 0px"
                      Padding="0px 150px 0px 0px"
                    />
                  </>
                )}
              </div>

              {SpecialSectionForDisruptX && (
                <>
                  <div className="Disrupt_Pres_image_sec">
                    <div className="Disrupt_Pres_image_sec_Left">
                      <div className="Disrupt_Pres_image_sec_Left_Text">
                        <Text
                          text="Reshaping"
                          FontWeight={"900"}
                          FontSize={"3.5rem"}
                          LineHeight={"1"}
                        />
                        <Text
                          text="the Future"
                          FontWeight={"900"}
                          FontSize={"3.5rem"}
                          Color={"#808080"}
                          LineHeight={"1"}
                        />
                        <Text
                          text="Fast Track IoT adoption"
                          FontWeight={"500"}
                          FontSize={"1.6rem"}
                          Color={"#808080"}
                          LineHeight={"1"}
                          Margin={"15px 0px 0px 0px"}
                        />
                      </div>
                      <div className="Disrupt_Pres_image_sec_Left_Image">
                        <ImageComp Src={"/Images/disruptpressimage1.webp"} />
                        <ImageComp
                          Src={"/Images/disruptpressimage2.webp"}
                          Margin={"0px 0px 0px 35px"}
                        />
                      </div>
                      <div className="MobDisrupt_Pres_image_sec_Left_Image">
                        <ImageComp Src={"/Images/Mobdisruptpressimage1.webp"} />
                        <ImageComp
                          Src={"/Images/Mobdisruptpressimage2.webp"}
                          Margin={"0px 0px 0px 35px"}
                        />
                      </div>
                    </div>

                    <div className="Disrupt_Pres_image_sec_right">
                      <ImageComp
                        Src={"/Images/disruptpressimage3.webp"}
                        Width="100%"
                      />
                    </div>
                    <div className="MobDisrupt_Pres_image_sec_right">
                      <ImageComp
                        Src={"/Images/Mobdisruptpressimage3.webp"}
                        Width="100%"
                      />
                    </div>
                    <div className="Mob_Disrupt_Pres_image_sec_Left_Text">
                      <Text
                        text="Reshaping"
                        FontWeight={"900"}
                        FontSize={"3.5rem"}
                        LineHeight={"1"}
                      />
                      <Text
                        text="the Future"
                        FontWeight={"900"}
                        FontSize={"3.5rem"}
                        Color={"#808080"}
                        LineHeight={"1"}
                      />
                      <Text
                        text="Fast Track IoT adoption"
                        FontWeight={"500"}
                        FontSize={"1.6rem"}
                        Color={"#808080"}
                        LineHeight={"1"}
                        Margin={"15px 0px 0px 0px"}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="MousCeremonyContent">
                <Text text={PressDetails} />
              </div>
              {PressImage && (
                <div className="PressReleaseImage">
                  <ImageComp
                    Src={PressImage}
                    Width={PressImageWidth}
                    Margin="80px 0px 0px 0px"
                    Radius={"0px"}
                  />
                </div>
              )}

              {/* ONLY FOR SPECTRACULAR NIGHT IN CHINESE TAIPEI PRESS RELEASE  */}
              {PressImageSlider1 && (
                <Swiper
                  className=" CryptopediaSider"
                  modules={[Autoplay, Scrollbar, A11y]}
                  spaceBetween={30}
                  slidesPerView={1}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: true, // Allow autoplay to continue after interaction
                  }}
                  onSlideChange={() => console.log("slide change")}
                  onSwiper={(swiper) => console.log(swiper)}
                >
                  <SwiperSlide>
                    <div className="PressReleaseImage">
                      <ImageComp
                        Src={PressImageSlider1}
                        Width={PressImageWidth}
                        Margin="80px 0px 0px 0px"
                        Radius={"0px"}
                      />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="PressReleaseImage">
                      <ImageComp
                        Src={PressImageSlider2}
                        Width={PressImageWidth}
                        Margin="80px 0px 0px 0px"
                        Radius={"0px"}
                      />
                    </div>
                  </SwiperSlide>
                </Swiper>
              )}

              {PressImageCaption && (
                <div className="MousCeremonyPressImageCaption">
                  <Text
                    Margin="50px 0px 30px 0px"
                    FontSize="1.2rem"
                    text={PressImageCaption}
                  />
                </div>
              )}
              {PressDetails2 && (
                <div className="MousCeremonyContent">
                  <Text text={PressDetails2} Margin={"80px 0px"} />
                </div>
              )}

              {SpecialSectionForDisruptX && (
                <div className="Press_Release_bottom">
                  <div className="DisruptSiteLinkSec">
                    <Text
                      text="For more details, please visit:<br>"
                      Margin="0px 2px 0px 0px"
                      FontSize="1.8rem"
                    />
                    <MyButton
                      RouteLink="https://dynasysnetworks.com"
                      FontSize="1.8rem"
                      text="https://dynasysnetworks.com"
                      FontWeight="400"
                    />
                    <MyButton
                      RouteLink="https://disrupt-x.io"
                      FontSize="1.8rem"
                      text="https://disrupt-x.io"
                      FontWeight="400"
                    />
                  </div>
                </div>
              )}

              {/* CONTACT DETAILS  */}
              {ContactUsHeading && (
                <div className="Press_Release_bottom">
                  <div className="SiteLinkSec">
                    <Text
                      text="For additional information, please contact the PR team:"
                      Margin="0px 2px 0px 0px"
                      FontSize="1.8rem"
                    />
                  </div>
                </div>
              )}

              <div className="PressReleaseTextAfterImg">
                {ContactOne && (
                  <>
                    <Text
                      Margin={`${
                        ContactUsHeading
                          ? "30px 0px 20px 0px"
                          : "80px 0px 20px 0px"
                      }`}
                      FontWeight={"800"}
                      text={ContactOne}
                    />
                    <Text text={ContactOneName} />
                    <div className="Azercosmos TextWithLink2">
                      <Text text=" (Email)" Margin={"0px 1rem 0px 0rem"} />
                      <MyButton
                        RouteLink={ContactOneEmailLink}
                        FontSize="1.8rem"
                        text={ContactOneEmail}
                        FontWeight="400"
                      />
                    </div>
                    {ContactOnePhone && (
                      <div className="Azercosmos TextWithLink2">
                        <Text text=" (Phone)" Margin={"0px 0.6rem 0px 0rem"} />
                        <Text text={ContactOnePhone} />
                      </div>
                    )}
                  </>
                )}

                {/* {ContactTwo && (
                  <>
                    <Text
                      Margin="50px 0px 20px 0px"
                      FontWeight={"800"}
                      text={ContactTwo}
                    />
                    <Text text={ContactTwoName} />
                    <div className="Azercosmos TextWithLink2">
                      <Text text=" (Email)" Margin={"0px 1rem 0px 0rem"} />
                      <MyButton
                        RouteLink={ContactTwoEmailLink}
                        FontSize="1.8rem"
                        text={ContactTwoEmail}
                        FontWeight="400"
                      />
                    </div>

                    <div className="Azercosmos TextWithLink2">
                      <Text text=" (Phone)" Margin={"0px 0.6rem 0px 0rem"} />
                      <Text text={ContactTwoPhone} />
                    </div>
                  </>
                )} */}

                {MuizzContact && (
                  <>
                    <div className="Press_Release_bottom">
                      <div className="SiteLinkSec">
                        <Text
                          text="For additional information, please contact the PR team:"
                          Margin="0px 2px 0px 0px"
                          FontSize="1.8rem"
                        />
                      </div>
                    </div>

                    {ContactTwo && (
                      <>
                        <Text
                          Margin="30px 0px 20px 0px"
                          FontWeight={"800"}
                          text={ContactTwo}
                        />
                        <Text text={ContactTwoName} />
                        <div className="Azercosmos TextWithLink2">
                          <Text text=" (Email)" Margin={"0px 1rem 0px 0rem"} />
                          <MyButton
                            RouteLink={ContactTwoEmailLink}
                            FontSize="1.8rem"
                            text={ContactTwoEmail}
                            FontWeight="400"
                          />
                        </div>
                        {ContactTwoPhone && (
                          <div className="Azercosmos TextWithLink2">
                            <Text
                              text=" (Phone)"
                              Margin={"0px 0.6rem 0px 0rem"}
                            />
                            <Text text={ContactTwoPhone} />
                          </div>
                        )}
                      </>
                    )}

                    <Text
                      Margin="30px 0px 20px 0px"
                      FontWeight={"800"}
                      text={"DynaSys Networks –"}
                    />
                    <Text text={"Abdul Muizz"} />
                    <div className="Azercosmos TextWithLink2">
                      <Text text=" (Email)" Margin={"0px 1rem 0px 0rem"} />
                      <MyButton
                        RouteLink={
                          "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=abdul.muizz@dynasysnetworks.com"
                        }
                        FontSize="1.8rem"
                        text={"abdul.muizz@dynasysnetworks.com"}
                        FontWeight="400"
                      />
                    </div>

                    <div className="Azercosmos TextWithLink2">
                      <Text text=" (Phone)" Margin={"0px 0.6rem 0px 0rem"} />
                      <Text text={"+92.317.508.1622"} />
                    </div>
                  </>
                )}
              </div>

              {/* OLD CONTACT dESIGN  */}
              {OldContactNameOne && (
                <div className="Press_Release_bottom">
                  <div className="DynasysPortnet SiteLinkSec">
                    <Text
                      text="For any inquiries, please reach out at:"
                      Margin="0px 2px 0px 0px"
                      FontSize="1.8rem"
                    />
                    <ul>
                      <li>
                        <Text
                          text={OldContactNameOne}
                          Margin="0px 2px 0px 0px"
                          FontSize="1.8rem"
                        />
                        <MyButton
                          RouteLink={OldContactOneEmailLink}
                          FontSize="1.8rem"
                          text="info@dynasysnetworks.com"
                          FontWeight="400"
                        />
                      </li>
                      {OldContactNameTwo && (
                        <li>
                          <Text
                            text={OldContactNameTwo}
                            Margin="0px 2px 0px 0px"
                            FontSize="1.8rem"
                          />
                          <MyButton
                            RouteLink={OldContactTwoEmailLink}
                            FontSize="1.8rem"
                            text="info@pronet-tech.net"
                            FontWeight="400"
                          />
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              )}

              {ForAnyQuery && (
                <div className="Press_Release_bottom">
                  <div className="SiteLinkSec">
                    <Text
                      text="For any inquiries, please reach out at"
                      Margin="0px 2px 0px 0px"
                      FontSize="1.8rem"
                    />
                    <MyButton
                      RouteLink="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=info@dynasysnetworks.com"
                      FontSize="1.8rem"
                      text="info@dynasysnetworks.com"
                      FontWeight="400"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div class="borderSec">
        <div class="border"></div>
      </div>
    </>
  );
}
